import { headers as defaultHeaders, PROFILE_STORAGE_KEY_EXPIRED_TIME } from './constants';
import { APIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import Identity from './identity';
import { UserIdentity, isUserIdentity } from './userIdentity';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';

/**
 *
 * Upon successful token exchange with the IDP, this API will register/authenticate the user and respond with Arc XP's access and refresh tokens.
 *
 * @param code OIDC code parameter
 *
 * @param state OIDC state parameter (optional)
 *
 * @returns
 * A __Promise__ with the user information. When successful, `userIdentity` will be populated with the data fetched by this method.
 *
 */

export default async function signInWithOIDC(
  code: string,
  state?: string
): Promise<APIErrorResponse | UserIdentity> {
  const headers: { [index: string]: any } = {
    ...defaultHeaders
  };

  if (
    Identity.userIdentity &&
    Identity.userIdentity.accessToken &&
    Identity.userIdentity.refreshToken
  ) {
    await Identity.heartbeat();
    headers['Authorization'] = `Bearer ${Identity.userIdentity.accessToken}`;
  }

  const getParams = () => {
    let params: { code: string } | { code: string; state: string } = {
      code
    };

    if (state) {
      params = { ...params, state };
    }

    return new URLSearchParams(params).toString();
  };

  return fetch(`${Identity.apiOrigin}/identity/public/v2/oidc/signin?${getParams()}`, {
    method: 'GET',
    headers: { ...headers }
  })
    .then(JSONResponseHandler)
    .then(json => {
      localStorage.removeItem(PROFILE_STORAGE_KEY_EXPIRED_TIME);

      if (isUserIdentity(json)) {
        Identity.userIdentity = json;
        window.postMessage({ type: 'ARC_LOGIN_SUCCESS', grantType: 'OIDC' }, '*');
        return Identity.userIdentity;
      } else {
        throw json;
      }
    });
}
